import { jsx, jsxs } from "react/jsx-runtime";
import { styled, useThemeProps } from "@biome-design-system/styles";
import { LinearProgress as MUILinearProgress } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { forwardRef } from "react";
import { Typography } from "../Typography/index.js";
const Wrapper = styled("div", {
  name: "MuiLinearProgress",
  slot: "wrapper"
})(({ theme }) => ({
  display: "flex",
  width: "100%",
  alignItems: "center",
  columnGap: theme.spacing(1),
  minHeight: theme.typography.body1.lineHeight
}));
const Label = styled(Typography, {
  name: "MuiLinearProgress",
  slot: "label"
})(() => ({
  width: "fit-content",
  minWidth: "2.75rem",
  textAlign: "right"
}));
const LinearProgressInner = (inProps, ref) => {
  const {
    id,
    label = ["indeterminate", "query"].some((v) => v === inProps.variant) ? (val) => {
      const intermediateState = inProps.variant === "query" ? "retrieving data" : "loading";
      return val === 100 ? "done" : intermediateState;
    } : (val) => `${val}%`,
    showLabel = false,
    value,
    ...restProps
  } = useThemeProps({
    props: inProps,
    name: "MuiLinearProgress"
  });
  const labelId = `${id}-label`;
  const labelText = typeof label === "function" ? label(value) : label;
  return /* @__PURE__ */ jsxs(Wrapper, { className: "MuiLinearProgress-wrapper", children: [
    /* @__PURE__ */ jsx(
      MUILinearProgress,
      {
        ...restProps,
        "aria-labelledby": labelId,
        id,
        ref,
        value
      }
    ),
    /* @__PURE__ */ jsx(
      Label,
      {
        className: "MuiLinearProgress-label",
        color: "text.secondary",
        id: labelId,
        role: "status",
        sx: showLabel ? void 0 : visuallyHidden,
        variant: "body1",
        children: labelText
      }
    )
  ] });
};
const LinearProgress = forwardRef(LinearProgressInner);
export {
  LinearProgress
};
